import { SampleStatus } from '../../interfaces/garments/sampleRequest.interface';

/**
 * Mirror of `SampleRequestService.STATUS_TRANSITIONS` (PATCH `{id}/status` — operational moves).
 * `SampleRequestList`/`SampleStatusDialog` use this — never the free-form status list — to decide
 * which "Change status" targets a row offers, so a dead/illegal button is never rendered.
 */
export const SAMPLE_STATUS_TRANSITIONS: Record<SampleStatus, SampleStatus[]> = {
    REQUESTED: ['IN_WORK', 'CANCELLED'],
    IN_WORK: ['SENT', 'CANCELLED'],
    SENT: [],
    APPROVED: [],
    REJECTED: [],
    RESUBMIT_REQUIRED: [],
    RESUBMITTED: [],
    CANCELLED: [],
};

/**
 * Mirror of `SampleRequestService.DECISION_TRANSITIONS` (PATCH `{id}/decision` — the buyer's call
 * on a sample that has been SENT). `SampleDecisionDialog` uses this to build its options.
 */
export const SAMPLE_DECISION_TRANSITIONS: Record<SampleStatus, SampleStatus[]> = {
    REQUESTED: [],
    IN_WORK: [],
    SENT: ['APPROVED', 'REJECTED', 'RESUBMIT_REQUIRED'],
    APPROVED: [],
    REJECTED: [],
    RESUBMIT_REQUIRED: [],
    RESUBMITTED: [],
    CANCELLED: [],
};

/**
 * Every backend `SampleStatus` value (mirrors `com.kervolt.oms.enums.SampleStatus`). Tests assert
 * both transition maps above are keyed by exactly this list, and that neither ever offers
 * `RESUBMITTED` as a target — that state is reachable only through `SampleRequestService.resubmit`
 * (POST `{id}/resubmit`, H5), never a status/decision PATCH.
 */
export const ALL_SAMPLE_STATUSES: SampleStatus[] = [
    'REQUESTED', 'IN_WORK', 'SENT', 'APPROVED', 'REJECTED', 'RESUBMIT_REQUIRED', 'RESUBMITTED', 'CANCELLED',
];

/** Statuses whose fields (`SampleRequestForm`) remain editable — mirrors `SampleRequestService.EDITABLE`. */
export const EDITABLE_SAMPLE_STATUSES: SampleStatus[] = ['REQUESTED', 'IN_WORK'];

export const legalStatusTargets = (current: SampleStatus): SampleStatus[] => SAMPLE_STATUS_TRANSITIONS[current] ?? [];
export const legalDecisionTargets = (current: SampleStatus): SampleStatus[] => SAMPLE_DECISION_TRANSITIONS[current] ?? [];
